import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { CustomerObjectsService } from "../../../../categories/customer-objects/customer-objects.service";
import { CustomerObjectServiceHistoryListItem } from "../../../models/customerObject/customer-object-service-history-list-item";
import { DialogService } from "@progress/kendo-angular-dialog";
import { CustomerObjectServiceHistoryDialogComponent } from "../customer-object-service-history-dialog/customer-object-service-history-dialog.component";

@Component({
	selector: 'customer-object-service-history-list',
	templateUrl: './customer-object-service-history-list.component.html',
	styleUrls: [
		'./customer-object-service-history-list.component.scss',
		'../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
	]
})
export class CustomerObjectServiceHistoryListComponent implements OnInit, OnChanges {
	
	@Input() customerObjectId: number;

	serviceHistory: CustomerObjectServiceHistoryListItem[] = [];
	loading: boolean = false;

	requestCompletedName = 'Проведено обслуживание';
	requestNotCompletedName = 'Запланировано обслуживание';

	constructor(
		private customerObjectsService: CustomerObjectsService,
		private dialogService: DialogService
	) { }

	ngOnInit(): void {
		this.initData();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.customerObjectId) {
			this.initData();
		}
	}

	initData() {
		const customerObjectId = +this.customerObjectId;
		if (!customerObjectId) {
			this.serviceHistory = [];
			return;
		}

		this.loading = true;
		this.customerObjectsService.getAllServiceHistory(customerObjectId).subscribe(resp => {
			this.serviceHistory = (resp || []).sort((a, b) =>
				(this.getDateTicks(b.actionDate) - this.getDateTicks(a.actionDate))
			);
			this.loading = false;
		}, () => this.loading = false);
	}

	get hasServiceHistory(): boolean {
		return this.serviceHistory && this.serviceHistory.length > 0;
	}

	openDetails(item: CustomerObjectServiceHistoryListItem) {
		const dialogRef = this.dialogService.open({
			content: CustomerObjectServiceHistoryDialogComponent,
			title: item.requestId ? this.requestCompletedName : this.requestNotCompletedName,
			width: '700px',
			height: '780px'
		});

		const dialog = <CustomerObjectServiceHistoryDialogComponent>dialogRef.content.instance;
		dialog.requestId = item.requestId;
		dialog.plannedMaintenanceId = item.plannedMaintenanceId;
	}

	private getDateTicks(value: Date): number {
		return value ? new Date(value).getTime() : 0;
	}
}
